var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLirariLogoSmallItalic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 88,
    viewBox: "0 0 71 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_226_367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.7642 79.5637C51.6969 73.9662 24.5831 43.0393 21.437 49.1226",
    stroke: "white",
    strokeWidth: 0.5,
    strokeDasharray: "12 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0298 77.9909C24.2669 75.7486 20.6025 68.4484 22.8447 61.6856C25.087 54.9228 32.387 51.2582 39.1498 53.5005C45.9127 55.7428 49.5773 63.0428 47.335 69.8056C45.0927 76.5685 37.7926 80.2332 31.0298 77.9909Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9106 67.1963C39.2667 73.5769 34.242 74.7736 25.0509 73.8522",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3945 62.0662C38.7112 67.9828 31.6238 69.5579 22.6264 69.0229",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7778 57.2896C36.1462 63.1504 31.2082 64.3574 22.2743 63.8418",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3823 53.9285C34.363 58.4784 30.8474 59.3092 24.3959 58.5831",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6082 53.3513C47.0441 56.4589 49.134 69.0571 38.682 78.1385",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5462 53.4344C40.0941 58.5217 42.8923 70.9073 38.6645 78.1909",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.48 53.3275L38.5243 78.1828",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4976 53.3531C26.4909 62.3584 30.4986 74.5207 38.5291 78.2813",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5057 53.2909C19.0539 64.46 23.7785 76.4426 38.5478 78.2762",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1501 5.77794L22.8682 61.606",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8208 6.51087L40.3988 7.78369C36.4067 17.1991 13.8038 26.163 9.00471 49.2027C19.0819 30.9043 23.7392 32.5541 32.5395 31.4874L40.3988 7.78369C40.5781 7.36076 40.7199 6.93696 40.8208 6.51087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8208 6.51087L32.5396 31.4874C23.7392 32.5541 19.0819 30.9043 9.00472 49.2027C14.0194 25.1281 38.4732 16.4222 40.8208 6.51087Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5799 51.8122C17.9287 56.5603 45.9829 84.6513 48.8236 79.4893",
    stroke: "white",
    strokeWidth: 0.5,
    strokeDasharray: "12 12"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_226_367"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.4032,
    height: 75.6966,
    fill: "white",
    transform: "matrix(-0.949187 -0.314713 -0.314713 0.949187 70.666 15.5078)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLirariLogoSmallItalic);
export default __webpack_public_path__ + "static/media/lirari-logo-small-italic.bfd445a8cdebea98ec37d2c4e21b3f06.svg";
export { ForwardRef as ReactComponent };